// extracted by mini-css-extract-plugin
module.exports = {"aplixImagePickerRoot":"aplixImagePickerRoot--ef7d0","cameraControlPanel":"cameraControlPanel--55a23"};